'use strict';

const {degToRad} = require('../utils/misc');
const DrawingElement = require('../classes/DrawingElement');
const Shape = require('../classes/Shape');
const Point = require('../classes/Point');

module.exports = new DrawingElement('auto-triangle', function () {
    let triangleSideLength = this.width - this.pad * 2;
    let triangleHeight = Math.sin(degToRad(60)) * triangleSideLength;

    const heightPadding = (this.width - triangleHeight) / 2;

    let shape = new Shape(3, triangleSideLength, new Point(this.pad + triangleSideLength, heightPadding + triangleHeight));
    shape.dotSize = 0.5;

    shape.draw(this.ctx);

    this.addRunButton(shape, 50000);
});


